module.exports = __webpack_public_path__ + "static/media/star-4.09e498cc.svg";